module.exports = __webpack_public_path__ + "assets/d47048a60dc372aa9776bb0b816bb238.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-vietnamese-300-normal.woff2
// module id = 2642
// module chunks = 121